const detailsanotations = (state = [], action) => {
    switch (action.type) {
      case 'DETAILSANOTATIONS':
      return {
          type: "DETAILSANOTATIONS",
          detailsanotations: action.detailsanotations
        }
      default:
        return state
    }
  }
  
  export default detailsanotations